import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

// export class EncrDecrService {
//   constructor() { }
//   //The set method is use for encrypt the value.
//   set(keys: any, value: any) {

//     return value;
//   }

//   //The get method is use for decrypt the value.
//   get(keys: any, value: any) {
    
//     return value;
//   }
// }
export class EncrDecrService {
  constructor() { }
  //The set method is use for encrypt the value.
    set(keys: any, value: any) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    var encryptedString =  encrypted.toString();
    return encryptedString;
  }

  //The get method is use for decrypt the value.
  get(keys: any, value: any) {
    var key = CryptoJS.enc.Utf8.parse(keys);
    var iv = CryptoJS.enc.Utf8.parse(keys);
    var decrypted = CryptoJS.AES.decrypt(value, key, {
      keySize: 128 / 8,
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    return decrypted.toString(CryptoJS.enc.Utf8);
    // return value;
  }
}